// two digits or chars
// two more digits
// another digit or space
// then 5 or 6 more digits
export const actionNumberPattern = /^[\dA-Z]{2}\d\d[\d ]\d{5,6}$/;
